import { Injectable } from '@angular/core';
import { ComparisonService } from '@comparison/feature';
import { MyShopService } from '@my-shop/feature';
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { UserProfileFacade } from '@spartacus/user';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable()
export class CustomCloseAccountComponentService {
  isLoading$ = new BehaviorSubject(false);

  constructor(
    private userProfile: UserProfileFacade,
    private globalMessageService: GlobalMessageService,
    private comparisonService: ComparisonService,
    private myShopService: MyShopService,
  ) {}

  closeAccount(): void {
    this.isLoading$.next(true);
    this.userProfile
      .close()
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.onSuccess();
          this.isLoading$.next(false);
        },
        error: () => {
          this.onError();
          this.isLoading$.next(false);
        },
      });
  }

  protected onSuccess(): void {
    this.comparisonService.reset();
    this.myShopService.removeMyShop();
    this.globalMessageService.add(
      { raw: 'Персональные данные успешно удалены.' },
      GlobalMessageType.MSG_TYPE_CONFIRMATION,
    );
  }

  protected onError(): void {
    this.globalMessageService.add({ raw: 'Персональные данные не удалены' }, GlobalMessageType.MSG_TYPE_ERROR);
  }
}
